import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveSignatureConfirmationDialog',
  emits: ["close", "confirm"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'close')
  (event: 'confirm')
}), expose: any, slots: any, attrs: any }) {



const cancel = () => {
  emits('close')
}

const confirm = () => {
  emits('confirm')
}

return { __sfc: true,emits, cancel, confirm, VsButton, VsText }
}

})